import { initializeApp, FirebaseError } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'
import useEmulators from '@/modules/emulators'

const mode = import.meta.env.MODE

const publicBaseUrl = import.meta.env.VITE_PUBLIC_BASE_URL

let authDomain = 'rc-zurich-app.firebaseapp.com'

if (publicBaseUrl) {
  try {
    authDomain = new URL(publicBaseUrl).hostname
  } catch (e) {
    console.error('Failed to parse VITE_PUBLIC_BASE_URL for authDomain:', e)
  }
}

const firebaseConfig = {
  apiKey: 'AIzaSyDL2PuJxJyD1Mk9ohw0Op7Fk1rnvngofNA',
  authDomain,
  projectId: mode === 'development' ? 'demo-rc-zurich-app' : 'rc-zurich-app',
  storageBucket: 'rc-zurich-app.appspot.com',
  messagingSenderId: '738891930240',
  appId: '1:738891930240:web:cd026a0b44d6a5d97ba465',
  measurementId: 'G-7FSK14HCP4'
}

const app = initializeApp(firebaseConfig)

export { FirebaseError }

export const firestore = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app, 'europe-west6')

if (mode === 'development') {
  useEmulators()
}

export default app
